export const tokens = {
    rgba: {
        // Burned
        pink: 'rgba(242, 20, 106, 0.6)',
        red: 'rgba(242, 20, 0, 0.6)',
        rust: 'rgba(106, 12, 14, 0.4)',
        // Listed
        cyan: 'rgba(0, 242, 200, 0.6)',
        lime: 'rgba(20, 242, 0, 0.6)',
        forest: 'rgba(12, 106, 14, 0.4)',
        // Sold
        void: 'rgba(24, 16, 42, 0.6)',
        // Other
        black: 'rgba(0, 0, 0, 1)',
        black40: 'rgba(0, 0, 0, 0.4)',
        black60: 'rgba(0, 0, 0, 0.6)',
    },
    stack: {
        gap: 8,
    },
    notice: {
        interior: {
            radius: 10,
            focusRing: {
                offset: 4,
                radius: 14,
            },
        },
        content: {
            gap: 10,
            padding: 6,
        },
        thumbnail: {
            size: {
                default: 46,
                compact: 36,
            },
            radius: 6,
        },
        message: {
            fontSize: {
                default: 14,
                compact: 12,
            },
        },
        suffix: {
            size: {
                default: 18,
                compact: 14,
            },
        },
    },
};
